import { defineComponent } from "../../../common/runtime/defineComponent.svelte.ts";
import type { Methods, Props } from "./ImageV1.types.ts";
import "./types.ts";
import { observeNearViewport } from "../../../common/utils/observeNearViewport.ts";

const isLoading = (host: Element) => !host.hasAttribute("state");

defineComponent<Props, Methods>({
  tag: "oc-image-v1",
  extendOptions: { useShadow: false },
  props: {
    variant: {
      reflect: true,
    },
    cutoutInnerBorderRadius: {
      type: "Boolean",
      attribute: "cutout-inner-border-radius",
      reflect: true,
    },
    aspectRatio: {
      attribute: "aspect-ratio",
      reflect: true,
    },
  },
  onMount: (host) => {
    /*                                                                                                    */
    /*                                                                                         */
    let release: (() => void) | undefined;
    const startWave = () => {
      if (!host.hasAttribute("state") && host.querySelector(':scope > img[loading="lazy"]'))
        release = observeNearViewport(host, isLoading);
    };

    host.setSrc = (src: string) => {
      host.style.removeProperty("--_backdrop-image");

      const img = host.querySelector(":scope > img");
      if (!(img instanceof HTMLImageElement)) {
        host.removeAttribute("state");
        return;
      }

      /*                                                                                */
      img.removeAttribute("srcset");
      img.setAttribute("src", src);
      window.ocImageApplySrcset?.(host as HTMLOcImageV1Element);

      /*                                                                                         */
      requestAnimationFrame(() => {
        if (img.complete) return;
        host.removeAttribute("state");
        startWave();
      });
    };

    /*                                                                   */
    if (import.meta.env.DEV) {
      window.ocImageApplySrcset?.(host as HTMLOcImageV1Element);
      const img = host.querySelector(":scope > img");
      if (img instanceof HTMLImageElement && img.complete) {
        host.setAttribute("state", img.naturalWidth ? "loaded" : "error");
        if (img.naturalWidth && host.matches("[variant=cutout],[variant=ambient-contain]"))
          host.style.setProperty("--_ratio", `${img.naturalWidth / img.naturalHeight}`);
      }
    }

    startWave();

    return () => release?.();
  },
});
